<div class="mb-3">
	<app-layer-selector
		(layerSelected)="this.onLayerSelection($event)"
		[layers]="this.customLayers"
		[selectedLayer]="this.selectedCustomLayer"
		[showModal]="this.showLayerSelectorModal"
		modalId="layerSelectorModal"
		selectElementId="selectLayerId"
		selectLabel="Seleziona livello:">
	</app-layer-selector>
</div>
<div>
	<div
		class="w-100"
		style="height: 750px"
		leaflet
		[leafletOptions]="options"
		[leafletLayersControl]="this.layersControl"
		(leafletMapReady)="onMapReady($event)"
		(leafletClick)="this.onMapClick($event)">
		@if (showMapLoadingSpinner) {
			<div class="overlay d-flex align-items-center justify-content-center">
				<app-loading-spinner></app-loading-spinner>
			</div>
		}
	</div>
</div>

<app-modal modalId="layerSelectorModal" [modal]="this.selectedCustomLayer.modal"></app-modal>
